module.exports = __webpack_public_path__ + "static/DC1-f2e5f3d319ddde85c1938347bd1efaa8.jpg";